import MoneyCharge from 'components/MoneyCharge';
import React from 'react';

function Wallet() {
  return <MoneyCharge />;
}

export default Wallet;
